export { default } from './WriteTemplate';



// WEBPACK FOOTER //
// ./src/components/write/WriteTemplate/index.js